import actions from './actions';
import reducer from './reducer';

const consultedCase = {
    actions,
    reducer,
    name: 'consultedCase',
};

export default consultedCase; 